import { useLayoutEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';

import { LOGIN_PATH } from '@perpay-web/authentication/constants/paths';
import { REFRESHING } from '@perpay-web/authentication/constants/states';
import { authentication } from '@perpay-web/authentication/singleton';
import WarningLoaderCircle from '@perpay-web/components/base/WarningLoaderCircle/WarningLoaderCircle';

const getIsRefreshing = (state) =>
    state.authentication.tokenState === REFRESHING;

const useRedirectIfUnauthenticated = () => {
    const navigate = useNavigate();
    const [isLoadingRedirect, setIsLoadingRedirect] = useState(true);
    const isAuthenticationRefreshing = useSelector(getIsRefreshing);

    useLayoutEffect(() => {
        if (isAuthenticationRefreshing) {
            return;
        }

        const params = new URLSearchParams(window.location.search);
        const postLoginPath = params.get('next') || window.location.pathname;
        params.set('next', postLoginPath);

        if (!authentication.getIsAuthenticated()) {
            navigate(`${LOGIN_PATH}?${params}`, { replace: true });
            return;
        }

        setIsLoadingRedirect(false);
    }, [isAuthenticationRefreshing, navigate]);

    return {
        isLoadingRedirect,
    };
};

export function withRedirectIfUnauthenticated(Component) {
    return (props) => {
        const { isLoadingRedirect } = useRedirectIfUnauthenticated();

        if (isLoadingRedirect) {
            return <WarningLoaderCircle />;
        }

        return <Component {...props} />;
    };
}
